export const forgivedDifferenceTimeManagement = 10;